import EmailInput from '../../../inputs/composed/EmailInput';
import TextInput from '../../../inputs/TextInput';
import CheckboxInput from '../../../inputs/CheckboxInput';
import { FormField } from '../type';
import RichText from '../../../RichText';
import { Box, Grid } from '@mui/material';
import SelectInput from '../../../inputs/SelectInput';
import FileInput from '../../../inputs/FileInput';
import { acceptAttribute } from './files/acceptAttribute';

const FieldRenderer = ({ field }: { field: FormField }) => {
  switch (field.blockType) {
    case 'email':
      return (
        <EmailInput
          name={field.name}
          label={field.label || ''}
          required={field.required}
          fullWidth
          errorGutterBottom
        />
      );
    case 'textarea':
      return (
        <TextInput
          name={field.name}
          label={field.label || ''}
          required={field.required}
          fullWidth
          multiline
          rows={4}
          errorGutterBottom
        />
      );
    case 'checkbox':
      return (
        <CheckboxInput
          name={field.name}
          label={<RichText withTypography>{field.label}</RichText>}
          errorGutterBottom
        />
      );
    case 'message':
      return <RichText>{field.message}</RichText>;
    case 'checkboxGroup': {
      return (
        <Box>
          <RichText>{field.label}</RichText>
          <Grid container>
            {field.options?.map((option, index) => {
              const columns = ((option.width || 100) / 100) * 12;
              return (
                <Grid key={option.id} size={{ xs: 12, md: columns }}>
                  <CheckboxInput
                    name={`${field.name}.${index}`}
                    label={<RichText withTypography>{option.label}</RichText>}
                    errorGutterBottom
                  />
                </Grid>
              );
            })}
          </Grid>
        </Box>
      );
    }
    case 'select':
      return (
        <SelectInput
          label={field.label || ''}
          required={field.required}
          name={field.name}
          fullWidth
          errorGutterBottom
          options={field.options || []}
        />
      );
    case 'file':
      return (
        <FileInput
          name={field.name}
          label={field.label || ''}
          required={!!field.required}
          multiple={!!field.multiple}
          accept={acceptAttribute(field)}
          fullWidth
          errorGutterBottom
        />
      );
    case 'text':
    default:
      return (
        <TextInput
          name={field.name}
          label={field.label || ''}
          required={field.required}
          fullWidth
          errorGutterBottom
        />
      );
  }
};

export default FieldRenderer;
